/**
 * Code points, not UTF-16 units: production counts the same way (`mb_strlen`),
 * and a cap enforced differently on the two sides would let a row the editor
 * accepted be refused at order time, or the reverse.
 */
function countCharacters(value: string): number {
  return [...value].length;
}

export default countCharacters;
